export const Types = {
    SCROLLPOS: 'SCROLLPOS',
    COLORS: 'COLORS',
    CONTENT: 'CONTENT',
    CANEDIT: 'CANEDIT',
    USER: 'USER',
};
